import React, { useState } from 'react';
import styled from 'styled-components';

import CardActionModal from './CardActionModal';

import Headline3 from '@joinforma/ui/components/Headline3';
import Body2 from '@joinforma/ui/components/Body2';
import Title1 from '@joinforma/ui/components/Title1';
import useSnackbar from '@joinforma/ui/hooks/useSnackbar';
import { ScreenWidth } from '@joinforma/ui/constants/breakpoints';

import useMutationUpdateFormaCardSettings from 'hooks/useMutationUpdateFormaCardSettings';
import EditAddressForm from './EditAddressForm';

import { FormaCard, FormaCardMember } from './types';
interface BillingAddressProps {
  physical_card_address: FormaCard['cardHolderDetails']['billingAddress'];
  physical_card_id?: FormaCard['cardId'];
  first_name: FormaCardMember['first_name'];
  refetchCards: () => void;
}

const BillingAddressContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    width: 100%;
    flex-direction: column;
    margin: 0 0 25px;
  }
`;

const PhysicalCardBilling = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    margin: 0 0 25px;
  }
`;

const BillingAddressTitle = styled(Headline3)`
  margin-bottom: 30px;
`;

const BillingAddressSubTitle = styled(Title1)`
  margin-bottom: 10px;
`;

const BillingAddressLine = styled(Body2)``;

const EditBillingAddress = ({
  physical_card_address,
  physical_card_id,
  first_name,
  refetchCards,
}: BillingAddressProps) => {
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar();

  const [
    is_edit_physical_billing_modal_open,
    setIsEditPhysicalBillingModalOpen,
  ] = useState(false);

  const { mutate: editBillingAddress } = useMutationUpdateFormaCardSettings({
    onSuccess: () => {
      refetchCards();
      showSuccessSnackbar({
        text: 'Your settings have been successfully updated.',
      });
    },
    onError: () => {
      showErrorSnackbar({ text: 'An error occurred. Please try again.' });
    },
  });

  return (
    <>
      <BillingAddressTitle>{`${first_name}'s billing info`}</BillingAddressTitle>
      <BillingAddressContainer>
        <PhysicalCardBilling>
          <BillingAddressSubTitle>
            Physical card billing address
          </BillingAddressSubTitle>
          <BillingAddressLine>
            {physical_card_address.street}
          </BillingAddressLine>
          <BillingAddressLine>
            {physical_card_address.street2}
          </BillingAddressLine>
          <BillingAddressLine>{`${physical_card_address.city}, ${physical_card_address.state} ${physical_card_address.postalCode}`}</BillingAddressLine>
          <CardActionModal
            is_open={is_edit_physical_billing_modal_open}
            title="Edit physical card billing address"
            onCancel={() => setIsEditPhysicalBillingModalOpen(false)}
          >
            <EditAddressForm
              billing_address={physical_card_address}
              confirm_button_text="Confirm"
              onCancel={() => setIsEditPhysicalBillingModalOpen(false)}
              handleEditBillingAddress={editBillingAddress}
              card_id={physical_card_id}
            />
          </CardActionModal>
        </PhysicalCardBilling>
      </BillingAddressContainer>
    </>
  );
};

export default EditBillingAddress;
